import ListView from './ListView.vue';
import EditView from './EditView.vue';
import ShowView from './ShowView.vue';

export default {
    ListView,
    EditView,
    ShowView
};